import { Provider } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as ADLThemeProvider } from "@adl/smart-ui-library";
import { MsalProvider } from "@azure/msal-react";
import { store } from "./redux/store";
import defaultTheme from "./themes/defaultTheme";
import MSALAuthentication from "./components/MSALAuthentication";
import { setTheme } from "./themes";
import { msalInstance } from "./authConfig";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import MyCasesPage from "./pages/MyCasesPage";
import SelectedCasePage from "./pages/SelectedCasePage";
import SelectedDocumentPage from "./pages/SelectedDocumentPage";
import SelectedNonPCodePage from "./pages/SelectedNonPCodePage";
import TasksPage from "./pages/TasksPage";
import NonPCode from "./pages/NonPCode";
import NonPCodeForm from "./pages/NonPCode/NonPCodeForm";

setTheme(defaultTheme);

function App() {
  const adlTheme = {
    ...defaultTheme,
    animationSpeed: 0.3,
  };

  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <ADLThemeProvider theme={adlTheme as any}>
          <MuiThemeProvider theme={defaultTheme}>
            <MSALAuthentication>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<MyCasesPage />} />
                  <Route
                    path="/case/:deliveryEngagementId"
                    element={<SelectedCasePage />}
                  />
                  <Route
                    path="/case/:deliveryEngagementId/document/:documentId"
                    element={<SelectedDocumentPage />}
                  />
                  <Route path="/tasks" element={<TasksPage />} />
                  <Route path="/non-p-code" element={<NonPCode />} />
                  <Route path="/upload" element={<NonPCodeForm />} />
                  <Route path="/edit" element={<NonPCodeForm />} />
                  <Route
                    path="/non-p-code/document/:documentId"
                    element={<SelectedNonPCodePage />}
                  />
                </Routes>
              </BrowserRouter>
            </MSALAuthentication>
          </MuiThemeProvider>
        </ADLThemeProvider>
      </Provider>
    </MsalProvider>
  );
}

export default App;
